import { CISO_CMRI_API } from '@/api';
import config from './transmissionViolationTestResultsConfigs';

const state = {
  tableData: [],
  tableConfig: {
    name: 'CMRITransmissionViolationTestResults',
    columns: config.fields,
    options: config.options,
  },
};

const actions = {
  async fetchData({ commit }, args) {
    commit('setTableData', []);

    const params = {
      startDate: args.tradeDateRangeSelected[0].format('YYYY-MM-DD'),
      endDate: args.tradeDateRangeSelected[1].format('YYYY-MM-DD'),
      marketType: args.marketTypeSelected, // as of now, only RTM is supported
      eim_entities: args.eimEntitySelected,
      inputTimeType: args.inputTimeTypeSelected,
    };
    try {
      const headers = { Accept: 'application/json' };
      const { data } = await CISO_CMRI_API.get('/eim-test-results/transmission-violation-tests', { params, headers });

      commit('setTableData', data);
    } catch {
      this.$notify('Failed to retrieve Transmission Violation Tests', 'error');
    }
  },
  reset({ commit }) {
    commit('setTableData', []);
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = Object.freeze(value);
  },
  setTableConfig(state, value) {
    state.tableConfig = value;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};